import type { RiskLevel } from "@/components/ui/risk-level-badge/RiskLevelBadge";

export function riskLevelDinNivel(
  nivel: string | null | undefined
): RiskLevel | null {
  switch (nivel) {
    case "de_baza":
      return "DE_BAZA";
    case "important":
      return "IMPORTANT";
    case "esential":
      return "ESENTIAL";
    case "neevaluat":
      return "NEEVALUAT";
    default:
      return null;
  }
}
